import { deepAnalysisApi } from '../service';
import { SeoAuditStructure, SeoAudit, FetchDomainAuditParams, FetchUrlAuditParams, WebsiteAuditOverview, FetchWebsiteAuditOverviewParams, FetchTopIssuesParams, WebsiteAuditSeoIssue } from './types';

const auditReportApi = deepAnalysisApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchAuditStructure: builder.query<SeoAuditStructure, void>({
            query: () => {
                return {
                    method: 'GET',
                    url: '/on-page-seo/audit/structure',
                };
            },
        }),

        fetchDomainAudit: builder.query<SeoAudit, FetchDomainAuditParams>({
            query: (args) => {
                const { w_guid } = args;

                return {
                    method: 'GET',
                    url: `/on-page-seo/audit/domain/${w_guid}`,
                };
            },

            providesTags: (result, error, args) => [{ type: 'DomainAudits', id: args.w_guid }],
        }),

        fetchUrlAudit: builder.query<SeoAudit, FetchUrlAuditParams>({
            query: (args) => {
                const { w_guid, url_guid } = args;

                return {
                    method: 'GET',
                    url: `/on-page-seo/audit/url/${w_guid}/${url_guid}`,
                };
            },

            providesTags: (result, error, args) => [
                { type: 'UrlAudits', id: args.w_guid },
                { type: 'UrlAudits', id: `${args.w_guid}_${args.url_guid}` },
            ],
        }),

        fetchWebsiteAuditOverview: builder.query<WebsiteAuditOverview, FetchWebsiteAuditOverviewParams>({
            query: (args) => {
                const { w_guid } = args;

                return {
                    method: 'GET',
                    url: `/on-page-seo/website-audit/overview/${w_guid}`,
                };
            },
        }),
        fetchTopIssues: builder.query<WebsiteAuditSeoIssue[], FetchTopIssuesParams>({
            query: (args) => {
                const { w_guid, limit } = args;

                return {
                    method: 'GET',
                    url: `/on-page-seo/website-audit/top-issues/${w_guid}?limit=${limit}`,
                };
            }
        }),
    }),
});

export const {
    useFetchAuditStructureQuery,
    useFetchDomainAuditQuery,
    useFetchUrlAuditQuery,
    useFetchWebsiteAuditOverviewQuery,
    useFetchTopIssuesQuery
} = auditReportApi;
